var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOtaIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 2L2 7V12C2 16.55 5.84 20.74 12 22C18.16 20.74 22 16.55 22 12V7L12 2ZM12 11.99H20C19.47 15.11 17.24 17.78 14 19.36V12H10V19.36C6.76 17.78 4.53 15.11 4 11.99H12V11.99ZM12 10V4.13L19.93 8L12 10Z",
  fill: "#BBBBBB"
})));
export { SvgOtaIcon as ReactComponent };
export default __webpack_public_path__ + "assets/38e0d3ed.svg";